$(function () {
  $(window).click(function () {
    $(".modernize-dropdown").addClass("hidden")
  })

  $(".modernize-dropdown-trigger").click(function (e) {
    e.stopPropagation()
    const $dropdown = $("#" + $(this).data("target"))
    const direction = $(this).data("direction")
    const $trigger = $(this)

    if ($dropdown.hasClass("hidden")) {
      $dropdown.removeClass("hidden")
    } else {
      $dropdown.addClass("hidden")
    }

    const top =
      direction === "top"
        ? $trigger.position().top - 5 - $dropdown.outerHeight(true)
        : $trigger.position().top + $trigger.outerHeight(true) + 5

    const targetPosition = {
      top: top,
      left: $trigger.position().left + $trigger.outerWidth(true) - $dropdown.outerWidth(true),
    }

    $dropdown.css(targetPosition)
  })
})
